import { SVGProps } from 'react';

function Search(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1169 15.6687C15.5292 14.2185 17.1198 10.2767 15.6696 6.8644C14.2194 3.4521 10.2776 1.8615 6.86528 3.3117C3.45298 4.76189 1.86238 8.70371 3.31257 12.116C4.76276 15.5283 8.70459 17.1189 12.1169 15.6687Z"
        stroke="#F5963D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2377 14.2368L19.4443 19.4442"
        stroke="#F5963D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

Search.defaultProps = {
  role: 'graphics-document',
};

export default Search;
